<template>
    <div class="buy-box" v-if="bodyShow">
        <!-- header -->
        <div class="buy-head">
            <img src="@a/training_success.png" alt="">
            <h2>购买成功</h2>
            <h3><span>付费金额：</span><small>¥{{price}}</small></h3>
        </div>
        <!-- content -->
        <div class="buy-content">
            <div class="buy-info">
                <img src="@a/training_code.png" alt="">
                <span>填写入学信息,解锁班主任微信</span>
            </div>
            <router-link class="edit-info-btn" 
                :to="{
                    path:'/training_information',
                    query:{
                        course_id:this.$route.query.course_id
                    }
                }"
            >填写入学信息</router-link>
        </div>
    </div>
</template>

<script>
import { buySucess } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
export default {
    data() {
        return{
            bodyShow:false,
            price:null
        }
    },
    methods:{
        pullData(){
            buySucess({
                course_id:this.$route.query.course_id
            }).then((data)=>{
                if (data.code && data.code === 10002) {
                    this.$dialog.alert({
                        message: data.data.msg
                    }).then(() => {
                        this.$router.push({
                            path:'/training_details',
                            query:{
                                course_id:this.$route.query.course_id
                            }
                        });
                    });
                    return;
                }
                this.price  = data.info.price;
                this.bodyShow = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon("training", this);
    }
    
}
</script>

<style lang="scss" scoped>
.buy-head{
    background: linear-gradient(to right,#F57F17 , #EB5032);
    height: 320px;
    color: #ffffff;
    text-align: center;
    padding: 57px 0;
    img{
        width: 86px;
        height: 86px;
    }
    h2{
        font-size: 54px;
        margin-top: 24px;
        line-height: 1;
    }
    h3{
        font-size: 30px;
        line-height: 1;
        margin-top: 16px;
        span{
            display: inline-block;
            vertical-align: middle;
        }
        small{
            font-size: 40px;
            display: inline-block;
            vertical-align: middle;
        }
    }
}
.buy-content{
    padding: 40px 30px 98px;
    text-align: center;
    .buy-info{
        border:2px solid rgba(204,204,204,1);
        border-radius:8px;
        padding: 33px;
        font-size: 28px;
        color: #333;
        vertical-align: middle;
        img{
            width: 48px;
            height: 48px;
            margin-right: 17px;
        }
    }
    .edit-info-btn{
        display: block;
        text-align: center;
        border: 2px solid #EB5032;
        width: 100%;
        line-height:80px;
        background:#EB5032;
        color: #ffffff;
        font-size: 34px;
        border-radius:8px;
        margin: 553px auto 0;
    }
}
</style>
